<div class="flex flex-col space-y-2">
    @if (navItems.primaries) {
        @for (primary of navItems.primaries; track primary.title) {
            <button
                [class]="primary.classList"
                type="button"
                mat-raised-button
                color="primary"
                [routerLink]="primary.routerLink"
                (click)="primary.action && primary.action()"
                [title]="primary.title"
                [disabled]="primary.disabled"
                class="flex items-center w-full"
            >
                @if (primary.imageUrl) {
                    <span class="flex items-center space-x-2">
                        <img
                            src="{{ primary.imageUrl }}"
                            alt=" {{ primary.title }}"
                            class="w-5 h-5"
                        />
                        <span> {{ primary.title }}</span>
                    </span>
                } @else {
                    <span> {{ primary.title }}</span>
                }
            </button>
        }
    }

    @if (navItems.secondaries) {
        @for (secondary of navItems.secondaries; track secondary.title) {
            <button
                [class]="secondary.classList"
                type="button"
                color="primary"
                mat-stroked-button
                [routerLink]="secondary.routerLink"
                (click)="secondary.action && secondary.action()"
                [title]="secondary.title"
                class="flex items-center w-full"
            >
                @if (secondary.imageUrl) {
                    <span class="flex items-center space-x-2">
                        <img
                            src="{{ secondary.imageUrl }}"
                            alt="{{ secondary.title }}"
                            class="w-5 h-5"
                        />
                        <span>{{ secondary.title }}</span>
                    </span>
                } @else {
                    <span>{{ secondary.title }}</span>
                }
            </button>
        }
    }
</div>
